import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class MultiLineText extends Component {
  static propTypes = {
    lines: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]).isRequired,
    useBreaks: PropTypes.bool,
  };

  static defaultProps = {
    useBreaks: false,
  };

  render() {
    const { lines, useBreaks } = this.props;

    const renderedText = Array.isArray(lines)
      ? lines.map((line, key) => {
          return useBreaks ? (
            <span key={key}>
              {line}
              <br />
            </span>
          ) : (
            <p key={key}>{line}</p>
          );
        })
      : lines;

    return <div>{renderedText}</div>;
  }
}
